@if (selectionReady) {
  <mat-form-field appearance="outline" class="dc-emp-picker search-field" subscriptSizing="dynamic">
    <mat-label>{{ "digitalCards.searchEmployeeLabel" | translate }}</mat-label>
    <input
      #searchInput
      matInput
      type="text"
      [formControl]="searchCtrl"
      [matAutocomplete]="empAuto"
      [disabled]="disabled"
      [placeholder]="'digitalCards.searchEmployeePlaceholder' | translate"
      (click)="onTriggerClick()"
      (blur)="onBlur()"
      autocomplete="off"
      role="combobox"
    />
    <mat-icon
      matSuffix
      class="dc-emp-picker__chevron"
      aria-hidden="true"
      (mousedown)="$event.preventDefault()"
      (click)="searchInput.focus(); searchInput.click()"
    >arrow_drop_down</mat-icon>
    <mat-autocomplete
      #empAuto="matAutocomplete"
      class="dc-emp-picker__panel"
      (optionSelected)="onOptionSelected($event)"
    >
      @if (options.length === 0) {
        <mat-option disabled>
          {{ "digitalCards.searchEmployeeEmpty" | translate }}
        </mat-option>
      } @else {
        @for (e of options; track optionTrackBy($index, e)) {
          <mat-option [value]="e" class="dc-emp-picker__option">
            <span class="dc-emp-picker__option-name">{{ fullName(e) || email(e) }}</span>
            @if (fullName(e) && email(e)) {
              <span class="dc-emp-picker__option-email">{{ email(e) }}</span>
            }
          </mat-option>
        }
      }
    </mat-autocomplete>
  </mat-form-field>
}
